<!-- 语言设置 -->
<script setup>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import i18n from "@/i18n"
import { onMounted, ref } from "vue";
import { getB2cList, postB2c, putB2c, deleteB2c } from "@/service/apiList/b2c.js"
import { showMessage } from "@/utils/hooks/message"
import { getLangValue } from "@/utils/common"; //获取后端语言
import { getBusinessInfoList, } from "@/service"
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import addCom from "./add.vue";
import Swal from "sweetalert2";
const title = i18n.global.t("menu.system_management")
const items = [
    {
        text: title,
    },
    {
        text: getLangValue("menu.b2c"),
        active: true,
    },
]

const tableData = ref([]); // 当前包含搜索条件的数据
const visible = ref(false) // 是否可新增  对于用户来说没啥用 只有开发者有用
const pageSizeOption = [10, 20, 30, 40, 50]
const { total, currentPage, pageSize, pageOption } = usetablePageNation(getData)
const formData = ref({
    company_id: '',
    ip: '',
    auth_key: '',
})
const companyList = ref([])
const keyword = ref('')
// methods



const getData = async () => {
    // 获取JSON数据
    let params = {
        page: currentPage.value - 1,
        limit: pageSize.value,
        keyword: keyword.value,
    }
    try {
        const reps = await getB2cList(params);
        if (reps.code == 0) {
            tableData.value = reps.payload.data;
            total.value = reps.payload.total;
        }
    } catch (e) {
        console.log(e);
    }
}

const submitForm = async (type = 1, item = {}) => {
    // 提交信息 type=1 表单来的  否则表格来的
    if (type == 1 && (formData.value.company_id == '' || formData.value.ip == '' || formData.value.auth_key == '')) {
        showMessage('danger', i18n.global.t("base.requiredinformation"));
        return;
    }

    if (type == 2 && (item.ip == '' || item.auth_key == '')) {
        showMessage('danger', i18n.global.t("base.requiredinformation"));
        return;
    }

    let params = {
        company: type == 1 ? formData.value.company_id : item.company_info?.id,
        ip: type == 1 ? formData.value.ip : item.ip,
        auth_key: type == 1 ? formData.value.auth_key : item.auth_key,
    }

    try {
        const resp = type == 1 ? await postB2c(params) : await putB2c(item.id, params)
        if (resp.code == 0) {
            showMessage('success', type == 1 ? getLangValue("base.add_success") : getLangValue("base.edit_success"))
            if (type == 1) {
                // 关闭新增状态
                visible.value = false;
                getData();
            }
        } else {
            showMessage('danger', resp.message)
        }
    } catch (e) {
        console.log(e);
    }



}

const getCompanyList = async () => {
    // 获取已通过企业list
    let params = {
        page: 0,
        limit: 0,
        status: 2, //类型
    }
    try {
        const resp = await getBusinessInfoList(params)
        if (resp.code == 0) {
            companyList.value = resp.payload.data;
        }
    } catch (e) {
        console.log(e);
    }
}

const handler = async (type, item) => {
    // 操作
    switch (type) {
        case 'edit':
            item.editing = true
            item.ip_copy = item.ip // 用来编辑
            item.auth_key_copy = item.auth_key // 用来编辑
            break;
        case 'save':
            item.ip = item.ip_copy // 用来编辑
            item.auth_key = item.auth_key_copy // 用来编辑
            //保存
            await submitForm(2, item)
            item.editing = false;
            break;
        case 'delete':
            //删除
            Swal.fire({
                title: getLangValue("base.delete_alert_title"),
                text: getLangValue("base.delete_alert_info"),
                icon: "warning",
                showCancelButton: true,
                cancelButtonColor: "#f46a6a",
                confirmButtonColor: "#34c38f",
                confirmButtonText: getLangValue("base.done"),
                cancelButtonText: getLangValue("base.cancel"),
            }).then(async (result) => {
                if (result.isConfirmed) {
                    // console.log(id)
                    deleteData(item)
                }
            });

            break;
    }
}

const deleteData = async ({ id }) => {
    // 删除
    try {
        const resp = await deleteB2c(id)
        if (resp.code == 0) {
            showMessage('success', getLangValue('base.delete_success'))
            getData();
        } else {
            showMessage('danger', resp.message)
        }
    } catch (e) {
        console.log(e);
    }
}

const handleEnter = () => {
    // 搜索
    currentPage.value = 1;
    getData();
}


// 加载完成
onMounted(() => {
    getData();
    getCompanyList();
})
</script>
<template>

    <Layout>
        <PageHeader :title="title" :items="items" />
        <div style="height: calc(100vh - 160px); " class=" d-flex">
            <div class="bg-white card  d-flex" style="flex: 8; flex-direction: column; height: 100%;">
                <div class="header1 py-2 px-3 d-flex align-items-center justify-content-between">
                    <div class="form-icon" style="width: 560px;">
                        <input type="text" class="form-control form-control-icon" v-model="keyword"
                            @keyup.enter="handleEnter" :placeholder="getLangValue('b2c.company_name')" />
                        <i class="ri-search-line"></i>
                    </div>
                    <div class="d-flex">
                        <b-button class="mx-2" variant="success" @click="visible = true"
                            v-permit="'system-management.language-configuration.modify'"
                            style="width: 104px; background-color: #0AB39C;display: flex; align-items: center;justify-content: center; width: 100px; height: 37px;border-color: unset; justify-content: center;">
                            <i class=" ri-edit-box-line ri me-2" style="font-size: 16px;"></i>{{ $t('base.add') }}
                        </b-button>
                    </div>
                </div>
                <div class="d-flex" style="flex-direction:column; flex: 1; height: calc(100% - 70px)">
                    <!-- 列表 -->
                    <div style="flex: 1; height: calc(100% - 37.5px - 2rem);">
                        <div class="d-flex align-items-center"
                            style="height: 44px; background-color: #F3F6F9; color: #9599AD; font-size: 14px;">
                            <div style="flex: 1; width: 30%;" class="ps-3">{{ getLangValue('b2c.company') }}</div>
                            <div style="flex: 1; width: 30%;" class="ps-3">{{ getLangValue('b2c.ip') }}</div>
                            <div style="flex: 1; width: 30%;" class="ps-3">{{ getLangValue('b2c.auth_key') }}</div>
                            <div style="flex: 1; width: 10%;" class="ps-3">{{ getLangValue('base.operation') }}</div>
                        </div>
                        <div class="my-scroll-bar" id="scrollBar" style="height: calc(100% - 44px);">
                            <template v-if="tableData.length">
                                <div style="height: calc(100% - 50px);overflow-y: auto;" class="my-scroll-bar">
                                    <div v-for="(item, k) in tableData" :key="k" class="d-flex align-items-center"
                                        style="min-height: 40px;border-bottom: 1px solid #E9EBEC;">
                                        <div style="flex: 1;width: 30%; white-space: normal; word-break: break-all;"
                                            class="ps-3">{{ item?.company_info?.company_name }}</div>
                                        <div style="flex: 1;width: 30%; white-space: normal; word-break: break-all;"
                                            class="ps-3">
                                            <input type="text" v-if="item.editing" class="form-control"
                                                v-model="item.ip_copy" :placeholder="getLangValue('b2c.ip')" />
                                            <span v-else>{{ item.ip }}</span>
                                        </div>
                                        <div style="flex: 1;width: 30%; white-space: normal; word-break: break-all;"
                                            class="ps-3">
                                            <textarea type="textarea" v-if="item.editing" class="form-control"
                                                v-model="item.auth_key_copy"
                                                :placeholder="getLangValue('b2c.auth_key')" />
                                            <span v-else>{{ item.auth_key }}</span>
                                        </div>
                                        <div style="flex: 1;width: 10%; white-space: normal; word-break: keep-all;"
                                            class="ps-3">

                                            <ul class=" list-inline hstack gap-2 mb-0 ">
                                                <li class="list-inline-item cursor" v-if="item.editing">
                                                    <div class="text-primary d-inline-block me-2"
                                                        @click="item.editing = false">
                                                        <i class="fs-20 ri-close-circle-fill"
                                                            style="color: #f06548;"></i>
                                                    </div>
                                                    <div class="text-primary d-inline-block"
                                                        @click="handler('save', item)"
                                                        v-permit="'business-user.modify'">
                                                        <i class="fs-20  ri-checkbox-circle-fill"></i>
                                                    </div>
                                                </li>
                                                <template v-else>
                                                    <li class="list-inline-item cursor">
                                                        <div class="text-primary d-inline-block"
                                                            @click="handler('edit', item)"
                                                            v-permit="'business-user.modify'">
                                                            <i class="fs-16 ri-pencil-fill"></i>
                                                        </div>
                                                    </li>
                                                    <!-- 删除 -->
                                                    <li class="list-inline-item" title="delete">
                                                        <div class="d-inline-block text-danger cursor"
                                                            @click="handler('delete', item)">
                                                            <i class="fs-16 ri-delete-bin-5-fill"></i>
                                                        </div>
                                                    </li>
                                                </template>
                                            </ul>

                                        </div>
                                    </div>
                                </div>
                                <!-- 分页 -->
                                <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize"
                                    :pages="pageOption" :prePageOption="pageSizeOption" :tab_info_length="total"
                                    class="me-5" style="margin-top: 0 !important;">
                                </Pagination>
                            </template>
                            <div v-else class="d-flex align-items-center justify-content-center h-100">
                                <Empty />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <addCom v-if="visible" v-model:visible="visible" :width="800">
            <div class="my-3">
                <div><span class="text-danger">*</span>{{ getLangValue('b2c.company') }}</div>
                <!-- <input type="text" class="form-control" v-model="formData.key" :placeholder="getLangValue('b2c.company')" /> -->
                <el-select style="width: 100%; height: 37.5px;" v-model="formData.company_id" filterable
                    :placeholder="getLangValue('b2c.company')" size="mini" clearable>
                    <el-option v-for="(item1, key) in companyList" :key="key" :label="item1.company_name"
                        :value="item1.id">
                    </el-option>
                </el-select>
            </div>
            <div class="form-icon my-3">
                <div><span class="text-danger">*</span>{{ getLangValue('b2c.ip') }}</div>
                <input type="text" class="form-control" v-model="formData.ip" :placeholder="getLangValue('b2c.ip')" />
            </div>
            <div class="form-icon my-3">
                <div><span class="text-danger">*</span>{{ getLangValue('b2c.auth_key') }}</div>
                <textarea type="textarea" class="form-control" v-model="formData.auth_key"
                    :placeholder="getLangValue('b2c.auth_key')" />
            </div>
            <div class="d-flex justify-content-end my-3">
                <b-button class="mx-2" variant="danger" @click="visible = false">{{ getLangValue('base.cancel')
                    }}</b-button>
                <b-button class="mx-2" variant="primary" @click="submitForm(1, {})">{{ getLangValue('base.confirm')
                    }}</b-button>
            </div>
        </addCom>
    </Layout>
</template>
<style lang="scss" scoped>
.header {
    min-height: 38px;
    font-weight: bold;
    font-size: 16px;
    // border-bottom: 1px dashed #E9EBEC;
}

.header1 {
    height: 70px;
    font-weight: bold;
    font-size: 16px;
    border-bottom: 1px dashed #E9EBEC;
}

.active {
    background-color: #F3F6F9;
    color: #9599AD;
}
</style>